angular.module('bmsApp.dashboard').factory('EcomDashboardSvc', function ($rootScope, CRUDSvc, $modal) {
	return {

		confirmJob: function (params) {
			return CRUDSvc.post('api/ecom/job/confirm', params);
		},

		cancelJob: function(params) {
			return CRUDSvc.post('api/ecom/job/cancel', params);
		},

		nonRefundedJobs: function(params) {
			return CRUDSvc.get('api/ecom/jobs/non-refunded', params);
		},

		markRefunded: function(params) {
			return CRUDSvc.post('api/ecom/job/mark-refunded', params);
		},

		updatedVisitDates: function(params) {
			return CRUDSvc.get('api/ecom/jobs/updated-visit-dates', params);
		},

		sendVisitChanged: function(params) {
			return CRUDSvc.post('api/ecom/jobs/send-updated-visit-dates', params);
		},

		ignoreUpdatedVisitDates: function(params) {
			return CRUDSvc.get('api/ecom/jobs/ignore-updated-visit-dates', params);
		},

		showAvailabilityModal: function() {
			let  modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/dashboard/templates/OnlineAvailabilityModal.html',
				controller: 'OnlineAvailabilityModalCtrl',
				controllerAs: 'Availability',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
			});

			return modalInstance.result;
		},

		getAvailability: function(params) {
			return CRUDSvc.post('api/ecom/availability/sample', params);
		}


	}
});



